import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const Battle = makeShortcode("Battle");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Incentive Notes" mdxType="SEO" />
    <h1 {...{
      "id": "incentive-notes"
    }}>{`Incentive Notes`}</h1>
    <h3 {...{
      "id": "monolith"
    }}>{`Monolith`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`$4260`}</strong>{`. One is enough, needed for Gaulteram for Verso endings`}</p>
    <h2 {...{
      "id": "with-painted-power"
    }}>{`With Painted Power`}</h2>
    <p>{`Buy `}<strong parentName="p">{`Gaulteram`}</strong><br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Recoat`}</strong>{`.`}</p>
    <p>{`After Creation, Recoat Verso. Give him Berserk Slash & Overload`}</p>
    <h3 {...{
      "id": "verso-ending"
    }}>{`Verso Ending`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Gaulteram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`Painted Power`}</li>
            <li parentName="ul">{`Shortcut`}</li>
            <li parentName="ul">{`Immaculate`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`-Augmented First Strike`}</li>
            <li parentName="ul">{`+SOS Power`}</li>
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "maelle"
      }}>{`Maelle`}</h4>
      <ol>
        <li parentName="ol">{`Attack`}</li>
        <li parentName="ol">{`Overload`}</li>
        <li parentName="ol">{`Berserk Slash`}</li>
      </ol>
    </Battle>
    <h2 {...{
      "id": "no-painted-power"
    }}>{`No Painted Power`}</h2>
    <Menu timing="Before next battle" mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <p>{`-+Verso, -+Maelle`}</p>
    </Menu>
    <p>{`Fight the Abberation (any battle works though).`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "abberation"
      }}>{`Abberation`}</h4>
      <ul>
        <li parentName="ul">{`Lune Wildfire Self, Flee`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "pick-up-charging-stun"
    }}>{`PICK UP CHARGING STUN`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <p>{`-+Lune`}</p>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`Gaulteram`}</strong>{` at Merchant`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "creation"
      }}>{`Creation`}</h4>
      <p>{`Verso Perfect Recovery, then flee.`}</p>
    </Battle>
    <Menu timing="Flag before Renoir" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +24 Agility (27)`}</li>
        <li parentName="ul">{`Verso: +24 Agility (51)`}</li>
        <li parentName="ul">{`Maelle: +24 Agility (51)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Earth Rising, +Thermal Transfer, +Crippling Tsunami`}</li>
        <li parentName="ul">{`Lune: Equip Crippling Tsunami Right-Middle`}</li>
        <li parentName="ul">{`Verso: Equip Quick Strike Right-Middle`}</li>
        <li parentName="ul">{`Maelle: +Phantom Strike`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Barrier Breaker +3 (18)`}</li>
      </ul>
    </Menu>
    <Menu timing="Before Renoir 3" mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <p>{`-+Verso`}</p>
      <h5 {...{
        "id": "picto"
      }}>{`Picto`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Charging Stun > Inverted Affinity`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy I > Critical Burn`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-1"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Augmented First Strike`}</li>
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`+Confident Fighter`}</li>
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+SOS Power`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-3"
      }}>{`Renoir 3`}</h4>
      <p>{`Counter everything.`}</p>
      <h5 {...{
        "id": "turn-0"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Verso: Energy Tint Lune`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: `}<strong parentName="li">{`Phantom Strike`}</strong></li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Verso: Leadership`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Verso: Berserk Slash / Defiant Strike if B rank?`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Shoot off Shields, Last Chance`}</li>
        <li parentName="ul">{`Lune: Energy Tint Self`}</li>
        <li parentName="ul">{`Verso: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Phantom Strike`}</li>
      </ul>
      <p>{`Should finish Phase 1 here, if not Wildfire instead and improvise`}</p>
      <h5 {...{
        "id": "turn-45"
      }}>{`Turn 4.5`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Crippling Tsunami`}</li>
        <li parentName="ul">{`Verso: Leadership`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Verso: Leadership`}</li>
      </ul>
      <h5 {...{
        "id": "turn-6"
      }}>{`Turn 6`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Swift Stride (Phantom Strike works too)`}</li>
        <li parentName="ul">{`Lune: Crippling Tsunami`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-7"
      }}>{`Turn 7`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "maelle-ending"
    }}>{`Maelle Ending`}</h3>
    <p><strong parentName="p">{`CHROMA ELIXER`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-1"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Weakness Gain > Augmented First Strike`}</li>
            <li parentName="ul">{`+Immaculate > SOS Power`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-2"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`+SOS Power`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "verso"
      }}>{`Verso`}</h4>
      <ul>
        <li parentName="ul">{`Last Chance`}</li>
        <li parentName="ul">{`Rain of Fire`}</li>
        <li parentName="ul">{`Swift Stride`}</li>
        <li parentName="ul"><em parentName="li">{`Can dodge if you want, will kill with burn tick`}</em></li>
        <li parentName="ul">{`Phantom Strike`}</li>
        <li parentName="ul">{`Rain of Fire`}</li>
      </ul>
    </Battle>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      